export var FilterType;
(function (FilterType) {
    FilterType["MULTI"] = "multi";
    FilterType["DATES"] = "dates";
    FilterType["TOGGLE"] = "toggle";
})(FilterType || (FilterType = {}));
